export function catalogToSelectOptions(catalog: {
  [index: string]: string | number | boolean;
}): { property: string; label: string | number | boolean }[] {
  return Object.entries(catalog).map((item) => ({ property: item[0], label: item[1] }));
}

interface removeFalseValuePropertiesParams {
  obj: { [p: string]: any };
  exclude?: any[];
}

export function removeFalseValueProperties(params: removeFalseValuePropertiesParams): { [i: string]: any } {
  const { obj = {}, exclude = [] } = params;
  return Object.fromEntries(Object.entries(obj).filter((item) => !!item[1] || exclude.includes(item[1])));
}

interface removeNullValuePropertiesParams extends removeFalseValuePropertiesParams {}

export function removeNullValueProperties(params: removeNullValuePropertiesParams): { [p: string]: string } {
  const { obj = {} } = params;
  return Object.fromEntries(Object.entries(obj).filter((item) => ![null, undefined, NaN].includes(item[1])));
}
